import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { STATS } from "@/data/content";

const CountUp = ({ to, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
};

export const StatsBar = () => (
  <section data-testid="stats-bar" className="bg-night py-20 text-cream">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mb-12 text-center">
        <Overline dark>The Work Behind the Mission</Overline>
      </Reveal>
      <div className="grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1} className="text-center">
            <p data-testid={`stat-value-${i}`} className="font-display text-5xl tracking-wide text-peach sm:text-6xl">
              <CountUp to={s.value} suffix={s.suffix} />
            </p>
            <p className="mx-auto mt-3 max-w-[12rem] font-heading text-xs font-semibold uppercase tracking-[0.18em] text-cream/70">
              {s.label}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
